import { Box, Button, Card, Container, FormControlLabel, Link, Radio, RadioGroup, Typography } from "@mui/material";
import { ArrowBack, ShoppingCart } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { WebStorageService } from "../services/WebStorageService";
import { DEFAULT_STOREID, ORDER_NOW } from "../contants/constants";
import products from "../data/products.json";
import { Order } from "../models/Order";
import { ProductService } from "../services/ProductService";
import { Product } from "../models/Product";

export default function OrderNowStep1() {
    const navigate = useNavigate();
    const [selectedSize, setSelectedSize] = useState('all');

    const webStorageService = new WebStorageService();
    const productService = new ProductService();
    const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);

    productService.Prices(DEFAULT_STOREID, products.map(m => m.ProductID).join(",")).then(result => {
        if (result.IsSuccessful) {
            let prices = result.Data || [];
            products.forEach(m => {
                //if no price found, the result of find() is undefined.
                let price = prices.find(p => p.ProductID === m.ProductID);
                if (price !== undefined)
                    m.Price = price.Price;
            });
            setSelectedProducts(products);
        }
    }).catch(error => {
        console.error(error);
    });

    function onBuy(item: any) {

        let order = webStorageService.getJson(ORDER_NOW) || new Order({ FirstName: "", LastName: "", MobilePhoneNumber: "", Address: "", Landmark: "", Product: undefined, OrderID: undefined });
        order.Product = item;
        webStorageService.setJson(ORDER_NOW, order);

        navigate("/order-now-step2")
    }

    function onSizeChange(event: React.ChangeEvent<HTMLInputElement>) {
        let size = (event.target as HTMLInputElement).value;
        setSelectedSize(size);
        if (size === 'all')
            setSelectedProducts(products);
        else
            setSelectedProducts(products.filter(m => m.QuantityPerUnit === Number(size)));
    }

    return (
        <Container>
            <Card sx={{ marginTop: { xs: 8, sm: 15 }, padding: { xs: 0, sm: 2 }, background: "#FEF9F8", marginX: "auto", boxShadow: { xs: 'none', md: 'var(--Paper-shadow)' } }}>
                <Box sx={{ display: 'flex', justifyContent: "space-between", alignItems: "baseline" }}>
                    <Typography variant="subtitle1" sx={{ marginBottom: {xs:3,sm:4,md:4}, margin:{xs:1,sm:0} }}>
                        <strong>Step 1:</strong> Pindutin ang <strong style={{ color: 'red' }}>BUY</strong> upang bumili.
                    </Typography>
                    <Box sx={{ display: { md: 'flex', lg: 'flex', xs: 'none', sm: 'none' } }}>
                        <RadioGroup row aria-labelledby={`rg1-label`} name="row-radio-buttons-group" value={selectedSize} onChange={onSizeChange}>
                            <FormControlLabel value="all" control={<Radio />} label="All" />
                            <FormControlLabel value="2.7" control={<Radio />} label="2.7kg" />
                            <FormControlLabel value="5" control={<Radio />} label="5kg" />
                            <FormControlLabel value="11" control={<Radio />} label="11kg" />
                            <FormControlLabel value="22" control={<Radio />} label="22kg" />
                            {/* <FormControlLabel value="50" control={<Radio />} label="50kg" /> */}
                        </RadioGroup>
                    </Box>
                </Box>


                <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: 'space-between', gap: { xs: 1, sm: 2 }, rowGap: { xs: 1.5, sm: 2 }, alignItems: 'center' }}>
                    {
                        selectedProducts.map(item => (
                            <Card sx={{ padding: { xs: 1, sm: 2 }, width: { xs: '43%', sm: '42%', md: '28%', lg: '20.5%' } }}>
                                <Box component="img" sx={{ width: '100%', minHeight: 150, objectFit: 'cover', objectPosition: { xs: '-50', md: 'center' } }} src={item.ImageFileName} alt={item.Name} loading="lazy" />

                                <Box sx={{ display: 'flex', justifyContent: "space-between", width: '100%' }}>
                                    <Box sx={{ width: '100%', justifyContent: "space-between", marginTop: 1 }}>
                                        <Typography variant="body2">{item.Name}</Typography>
                                        <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "space-between", marginTop: 1 }}>
                                            <Typography variant="subtitle2" style={{ color: "red" }}><span style={{ color: "red", fontSize: 10 }}>₱</span> {item.Price}</Typography>

                                            <Button
                                                variant="contained"
                                                size="small"
                                                sx={{ color: 'white', margin: { right: 15 }, background: "#d32f2f" }}
                                                onClick={() => onBuy(item)}><ShoppingCart sx={{ display: { xs: "none", sm: "flex" } }} /> Buy
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>

                            </Card>
                        ))
                    }
                </Box>
                <Box sx={{ marginBottom: 3, marginTop: 4 }}>
                    <Link onClick={(e) => { navigate("/get-started"); }} variant="body2" sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}><ArrowBack></ArrowBack> GO BACK</Link>
                </Box>
            </Card>
        </Container>
    );
}